export function isSelectionRenderable(selection: any): boolean {
    return !!selection
        && Array.isArray(selection.hippodrome?.runs)
        && selection.bettingType?.column != null
        && typeof selection.bettingSubType?.label === "string";
}
